<template>
  <div>
    <el-tree
      node-key="uid"
      :data="treeData"
      accordion
      :default-expanded-keys="getDefaultCheckedKeys"
      highlight-current
      :props="defaultProps"
      @node-click="handleNodeClick"
      :render-content="renderContent"
    ></el-tree>
  </div>
</template>

<script>
import { getAllColsUidInLayoutComponent, handleFindLayoutComponentOptionsCols } from "utils"
import { v1 } from "uuid"
const uuid = { v1 }
import { primaryBigScreenGenerator as primarybigScreenGenerator } from "@/store/modules/bigScreen/state"
import { primaryStageGenerator as primarystageGenerator } from "@/store/modules/stage/state"
import { primaryAppStageGenerator as primaryappStageGenerator } from "@/store/modules/appStage/state"
const mockData = { primarybigScreenGenerator, primaryappStageGenerator, primarystageGenerator }
import layer from "./layer"
export default {
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      }
    }
  },
  components: {layer},
  computed: {
    treeData: {
      get() {
        const data = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page.layoutOption.rows))
        formate(data)
        this.treeData = data
        function formate(data, len = 1) {
          data.forEach(item => {
            if (item.height) {
              item.label = { value: "布局", type: "row" }
            } else {
              item.label = { value: "布局", type: "col" }
            }
            for (const k in item) {
              const element = item[k]
              if (Array.isArray(element)) {
                item.children = element
                delete item[k]
                formate(item.children, len + 1)
              }
            }
          })
        }
        return data
      },
      set(val) {
        // console.log(val)
      }
    },
    getDefaultCheckedKeys() {
      return [this.$store.state[this.request_prefix].page.layoutOption.buttonContextUid || ""]
    }
  },
  methods: {
    clearItem(data) {
      this.$confirm("删除当前布局后，布局内的内容及布局都将会清空, 是否继续?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          const type = data.width ? "cols" : "rows"
          const { uid, children } = data
          this.forMateData(children)
          const rows = type === rows ? [{ height: "100%", uid: "", cols: children }] : children
          const _uid = getAllColsUidInLayoutComponent(rows) //获取当前选中行内的所有底层col的uid
          _uid.forEach(uid => {
            const { container_id } = handleFindLayoutComponentOptionsCols(rows, uid) //获取对应col的containerid
            console.log(container_id)
            this.$store.dispatch(this.request_prefix + "/deleteContainer", container_id) //删除当前contaienr
          })
          //删除当前选中的rows对应的布局中的cols数组
          this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
            key: type === "cols" ? "rows" : "cols",
            uid: uid,
            type: "del"
          })
          //设置新的默认container的options
          const stageOpt = {
            options: {
              background: {
                0: { color: this.request_prefix.includes("bigScreen") ? "rgb(0, 4, 58)" : "rgba(255,255,255,1)" }
              }
            }
          }
          //生成新的container的数据
          const param = {
            container_data: new mockData["primary" + this.request_prefix + "Generator"](stageOpt)
          }
          //新增画布
          this.$store.dispatch(this.request_prefix + "/insertContainer", JSON.parse(JSON.stringify(param)))
          const stages = this.$store.state[this.request_prefix].page.children
          const newContainer_id = stages[stages.length - 1].container_id //获取新画布的id

          //将当前行的cols数组进行重新赋值
          if (type == "rows") {
            const newCol = [
              {
                with: "100%",
                uid: uuid.v1(),
                container_id: newContainer_id
              }
            ]
            this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
              key: "cols",
              uid: uid,
              value: newCol
            })
          } else {
            this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
              key: "container_id",
              uid: uid,
              value: newContainer_id
            })
          }
          this.$message({
            type: "success",
            message: "删除成功!"
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "删除失败"
          })
        })
    },
    append(data) {
      const newChild = { label: "layer", container_id: data.container_id }
      if (!data.children) {
        this.$set(data, "children", [])
      }
      data.children.push(newChild)
    },
    forMateData(data) {
      if (Array.isArray(data)) {
        data.forEach(item => {
          if (item.children) {
            if (item.width) {
              item.rows = item.children
            } else {
              item.cols = item.children
            }
            this.forMateData(item.children)
            delete item.children
          }
        })
      }
    },
    renderContent(h, { node, data, store }) {
      if (data.label === "layer") {
        return <layer pageIndex={data.container_id} isNest={true} />
      } else
        return (
          <p class="icon-ol">
            <span class={data.label.type.includes("row") ? "icon-portal-row" : "icon-portal-col"} style="marginRight:4px" />
            {data.label.value}
            {data.children ? (
              <span vOn:click={this.clearItem.bind(this, data)} class="icon-portal-delete1" style="marginLeft:4px" />
            ) : (
              ""
            )}
          </p>
        )
    },
    handleNodeClick(tar, node, el) {
      if (tar.label === "label") return
      this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
        key: "buttonContextUid",
        value: tar.uid
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-tree-node__content:hover {
  background-color: var(--elTreeHoverColor) !important;
  color: var(--elCollapseItemContentColor);
}
::v-deep .is-current > .el-tree-node__content {
  background-color: var(--elTreeActiveColor) !important;
  /* background: var(--elCollapseItemWrapBgColor) !important */
}
::v-deep .el-tree-node__content {
  height: 32px !important;
  background: var(--elCollapseItemWrapBgColor) !important;
}
::v-deep .el-tree {
  background: var(--elCollapseItemWrapBgColor) !important;
  color: var(--elCollapseItemContentColor);
}
</style>
